import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getBusDetails, fetchGet, get24HoursDateTime, getDateFormString,getDateFormatIPhone } from '../../common/common';
import { getEditPolicyResults, getOldSeat, getEditPolicyData, setNewDepartDate } from '../../actions/editPolicy-actions';
import Listing from '../listing/Listing';
import CustomDatePicker from '../datepicker/CustomDatePicker';
import store from '../../store';
import './search.css';
import Calendar from './calendar';

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            departDate: this.props.editPolicy.newDepartDate ? this.props.editPolicy.newDepartDate : '',
            showDatePicker: false,
            modifyDepartDate: false,
        }
    }

    componentDidMount() {
        let url = '/api/resource/BookingInfo?PNR=' + this.props.match.params.pnrNo;

        //for app webview pass app agentId in api
        const appAgentId = localStorage.getItem("AgentId");
        if(appAgentId){
            url+='&appAgentId='+appAgentId;
        }

        fetchGet(url).then((data) => {
            if (data.Status) {
                store.dispatch(getEditPolicyResults(data.BookingInfo));
                store.dispatch(getEditPolicyData(JSON.parse(JSON.stringify(data.BookingInfo))));
                store.dispatch(getOldSeat(JSON.parse(JSON.stringify(data.BookingInfo.APIGetBookingDetailsResult[0].PaxDetail))));
                this.getDetails();
            } else {
                alert(data.Error);
            }
        }).catch(function (error) {
            store.dispatch(getEditPolicyResults(false));
            console.log(error);
        });
    }

    getDetails = () => {
        let depDate;
        let APIGetBookingDetailsResult = this.props.editPolicy.data.APIGetBookingDetailsResult[0];
        if (this.state.departDate === '') {
            depDate = APIGetBookingDetailsResult.JourneyDate;
        } else {
            depDate = this.state.departDate;
        }
        let fromCityId = APIGetBookingDetailsResult.FromCityID;
        let fromCityName = APIGetBookingDetailsResult.FromCityName;
        let toCityId = APIGetBookingDetailsResult.ToCityID;
        let toCityName = APIGetBookingDetailsResult.ToCityName;
        let mode = 'oneway';
        getBusDetails(fromCityId, fromCityName, toCityId, toCityName, depDate, mode);
    }

    modify = () => {
        this.setState({ showDatePicker: !this.state.showDatePicker });
    }

    onDateChange = (selecteddate) => {
        let getBookingInfo = this.props.editPolicy.data;
        getBookingInfo.APIGetBookingDetailsResult[0]['JourneyDate'] = selecteddate;
        store.dispatch(getEditPolicyResults(getBookingInfo));
        store.dispatch(setNewDepartDate(selecteddate));

        this.setState({ departDate: selecteddate, showDatePicker: false, modifyDepartDate: true }, () => { this.getDetails() });

    }

    getDatePicker = (depDate) => {
        if (this.state.showDatePicker)
            //return <CustomDatePicker depDate={depDate} onSelect={this.onDateChange} />
            return <div className='calender-wrapper2'><Calendar journeyDate={depDate} onSel={this.onDateChange} className='cal-head-top2' hideCalHeaderTop={true} /></div>
        else
            return null;
    }

    goBack = (e) => {
        setTimeout(() => { window.history.back() }, 100)
    }

    showModifyJourneyDate = (journeyTime, journeyDate) => {

        return (
            <div style={{ height: '100%', width: '100%', background: '#eee' }}>
                <div className='top-wrapper' style={{ background: window.color['searchBoxBgColor'] }}>
                    <span className='back-arrow' onClick={(event) => this.goBack(event)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='25px' fill='#fff'>
                            <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z" />
                        </svg>
                    </span>
                    <span className='header-title'>
                        Modify Your Journey Date
                    </span>
                </div>
                <div className='current-date-wrapper' style={{ background: window.color['searchBoxBgColor'] }}>
                    Current Journey Date-Time: {get24HoursDateTime(journeyTime)}
                </div>
                <div className='calender-wrapper'>
                    <Calendar journeyDate={this.state.departDate ? this.state.departDate : journeyDate} onSel={this.onDateChange} className='cal-head-top' hideCalHeaderTop={true} />
                </div>
            </div>
        )
    }

    showSchePage = (fromCityName, toCityName, journeyDate) => {
        return (
            <div style={{ height: '100%', width: '100%', background: '#eee' }}>
                {this.getDatePicker(this.state.departDate ? this.state.departDate : journeyDate)}
                <div className='top-wrapper' style={{ background: window.color['searchBoxBgColor'] }}>
                    <span className='back-arrow' onClick={(event) => this.goBack(event)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='25px' fill='#fff'>
                            <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z" />
                        </svg>
                    </span>
                    <span className='header-title date-title-wrap'>
                        <span className='title-trip-date'>Modified Trip: {getDateFormatIPhone(this.state.departDate,'ddd, DD MMM')}</span>
                        <span>{fromCityName} - {toCityName}</span>
                    </span>
                    <span className='modify' id='datepicker' onClick={() => this.modify()}>
                        Modify
                    </span>
                </div>
                <div className='ep-wrapper' style={{ zIndex: '5', content: "", clear: 'both', display: 'block', padding: '75px 20px 0px 20px' }}>
                    <Listing />
                </div>
            </div>
        )
    }

    render() {

        let APIGetBookingDetailsResult = this.props.editPolicy.data.APIGetBookingDetailsResult ? this.props.editPolicy.data.APIGetBookingDetailsResult[0] : '';
        let fromCityName = APIGetBookingDetailsResult ? APIGetBookingDetailsResult.FromCityName : '';
        let toCityName = APIGetBookingDetailsResult ? APIGetBookingDetailsResult.ToCityName : '';
        let journeyDate = APIGetBookingDetailsResult ? APIGetBookingDetailsResult.JourneyDate : '';
        let journeyTime = APIGetBookingDetailsResult ? APIGetBookingDetailsResult.PickupDate : '';

        if (APIGetBookingDetailsResult) {
            return (
                <div>
                    {
                        (this.props.editPolicy.newDepartDate == '' && !this.state.modifyDepartDate) ?
                            this.showModifyJourneyDate(journeyTime, journeyDate)
                            :
                            this.showSchePage(fromCityName, toCityName, journeyDate)
                    }
                </div>
            );
        } else {
            return (
                <div style={{ position: "fixed", textAlign: "center", paddingTop: "50%", width: "100%", height: "100%", backgroundColor: "rgba(255,255,255,0.6)" }}>Loading....</div>
            );
        }

    }
}

const mapStateToProps = function (store) {
    return (store);
};

export default connect(mapStateToProps)(Search);


// WEBPACK FOOTER //
// ./src/components/search/Search.js